module.exports = __webpack_public_path__ + "static/media/WS.7c30820f.svg";